<!-- Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. -->

<div
	*ngIf="_hasTicketsInEdit$ | async"
	[planPositioning]="positionContainer$"
	class="ticket-work-days-container"
>
	<span
		class="popup-widthless--blue ticket-work-days-control-message"
		*ngIf="noteVisible$ | async"
		@fadeInOut
	>
		{{ controlMessage$ | async }}
	</span>
</div>
